// PrivacyPolicy.jsx
import React, { useEffect, useState } from 'react';
import { BreathAPIs } from '../../../APIs/BreathAPIs';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';


import styles from './styles.module.css';

const ChargerMetric = ({ charger, fromDate, toDate }) => {

    const [isLoading, setIsLoading] = useState(true);
    const [isChargerLoading, setIsChargerLoading] = useState(false);

    const [selectedTopTab, setSelectedTopTab] = useState(0);


    const [chargerMetric, setChargerMetric] = useState([]);
    const [chargerUtilizationData, setChargerUtilizationData] = useState([]);

    const formatDuration = (seconds) => {
        if (seconds === 0 || seconds === null) return "0m";
        
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
    
        const hoursStr = hours > 0 ? `${hours}h ` : '';
        const minutesStr = minutes > 0 ? `${minutes}m` : '';
    
        return `${hoursStr}${minutesStr}`.trim();
    };


    const formatDate = (dateString) => {
        const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        const dateToConvert = new Date(dateString || Date.now());
        const month = months[dateToConvert.getMonth()];
        const day = dateToConvert.getDate();
        const year = dateToConvert.getFullYear();
        return `${month} ${day} ${year}`;
    }


    const fetchChargerMetric = async () => {
        try {
            setIsLoading(true);
            setChargerMetric([]);
            const data = await BreathAPIs.getChargerMetric(charger?.chargerID, fromDate, toDate, true);
            setChargerMetric(data.data);
        } catch (error) {
            console.error('Error fetching location data:', error);
        } finally {
            setIsLoading(false);
        }
    };


    const fetchChargerUtilizationData = async () => {
        try {
            setIsChargerLoading(true);
            setChargerUtilizationData([]);
            const data = await BreathAPIs.getChargerUtilizationData(charger?.chargerID, fromDate, toDate ,true);
            setChargerUtilizationData(data.data.data);
        } catch (error) {
            console.error('Error fetching charger data:', error);
        } finally {
            setIsChargerLoading(false);
        }
    };

    useEffect(() => {
        if (charger) {
            fetchChargerMetric();
        }
    }, [charger, fromDate, toDate]);

    useEffect(() => {
        if (selectedTopTab === 1) {
            fetchChargerUtilizationData();
        }
    }, [selectedTopTab]);


    return (
        <div className={styles.ChargerMetric}>

            {charger && !isLoading && chargerMetric ? <div>

                <div className={styles.topBlockContainer}>
                    <div className={styles.topBlock}>
                        <span>{chargerMetric?.EnergyValue?.chargerName}</span>
                        <span>{chargerMetric?.EnergyValue?.connectorStatus}</span>
                    </div>
                    <div className={styles.topBlock}>
                        <span>Charger Status</span>
                        <span>{chargerMetric?.EnergyValue?.chargerStatus}</span>
                    </div>
                    <div className={styles.topBlock}>
                        <span>Total Utilized Energy</span>
                        <span>{chargerMetric?.EnergyValue?.totalUtilizedEnergy?.toFixed(4)} kWh</span>
                    </div>
                </div>

                <div className={styles.topTabs}>
                    <div className={selectedTopTab === 0 ? styles.active : undefined} onClick={() => setSelectedTopTab(0)}>Utilized Energy</div>
                    <div className={selectedTopTab === 1 ? styles.active : undefined} onClick={() => setSelectedTopTab(1)}>Utilization</div>
                </div>

                {isChargerLoading &&
                    <div className={`${styles.locationBlocks} ${styles.loading} mt-4`}>
                        <p className={`card-text placeholder-wave`}><span className="placeholder col-12"></span></p>
                        <p className={`card-text placeholder-wave`}><span className="placeholder col-12"></span></p>
                    </div>
                }

                {selectedTopTab === 0 && <div className={styles.bottomBlockContainer}>
                    <div className={styles.bottomBlock}>
                        {/* <span>{formatDate(fromDate)} - {formatDate(toDate)}</span> */}
                        <span>{formatDate(chargerMetric?.EnergyValue?.filterByDate?.from)} - {formatDate(chargerMetric?.EnergyValue?.filterByDate?.to)}</span>

                        <ResponsiveContainer width="100%" height={300} >
                            <LineChart data={chargerMetric?.EnergyValue?.graphResult} margin={{ top: 5, right: 5, left: 5, bottom: 5 }}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="_id" />
                                <YAxis yAxisId="left" stroke="#ff7300" />
                                <YAxis yAxisId="right" orientation="right" stroke="#387908" />
                                <Tooltip />
                                <Legend />
                                <Line yAxisId="left" name={'Total Utilized Energy'} type="monotone" dataKey="totalUtilizedEnergy" stroke="#ff7300" activeDot={{ r: 8 }} />
                                <Line yAxisId="right" type="monotone" name={'Session Count'} dataKey="sessionCount" stroke="#387908" />
                            </LineChart>
                        </ResponsiveContainer>
                    </div>
                </div>}

                {!isChargerLoading && selectedTopTab === 1 && <>
                    {/* <div className={styles.topHead}>
                        Today's
                        <div className={styles.topBlockContainer}>
                            <div className={styles.topBlock}>
                                <span>Utilization</span>
                                <span>{(chargerUtilizationData?.utilizationPercentageCurrentDay ?? 0).toFixed(2)}%</span>
                            </div>
                            <div className={styles.topBlock}>
                                <span>Day Utilization</span>
                                <span>{(chargerUtilizationData?.dayUtilizationPercentageCurrentDay ?? 0).toFixed(2)}%</span>
                            </div>
                        </div>
                        <div className={styles.topBlockContainer}>
                            <div className={styles.topBlock}>
                                <span>Utilized Time</span>
                                <span>{(isNaN(chargerUtilizationData?.totalUtilizedTimeCurrentDay) ? '0m' : formatDuration(chargerUtilizationData?.totalUtilizedTimeCurrentDay))}</span>
                            </div>
                            <div className={styles.topBlock}>
                                <span>Booking Duration</span>
                                <span>{isNaN(chargerUtilizationData?.totalBookingDurationInSecondsCurrentDay) ? '0m' : formatDuration(chargerUtilizationData?.totalBookingDurationInSecondsCurrentDay)}</span>
                            </div>
                            <div className={styles.topBlock}>
                                <span>Bookings</span>
                                <span>{(chargerUtilizationData?.numberOfBookingsCurrentDay ?? 0).toFixed(0)} Nos</span>
                            </div>
                        </div>
                    </div> */}

                    <div className={`${styles['topHead']} ${styles['bottomRound']}`}>
                        {/* Whole Time */}
                        <span>{formatDate(chargerUtilizationData?.dateRange?.fromDate )} - {formatDate(chargerUtilizationData?.dateRange?.toDate )}</span>
                        <div className={styles.topBlockContainer}>
                            <div className={styles.topBlock}>
                                <span>Utilization</span>
                                <span>{(chargerUtilizationData?.utilizationPercentage ?? 0).toFixed(2)}%</span>
                            </div>
                            <div className={styles.topBlock}>
                                <span>Day Utilization</span>
                                <span>{(chargerUtilizationData?.dayUtilizationPercentage ?? 0).toFixed(2)}%</span>
                            </div>
                        </div>
                        <div className={styles.topBlockContainer}>
                            <div className={styles.topBlock}>
                                <span>Utilized Time</span>
                                <span>{(isNaN(chargerUtilizationData?.totalUtilizedTime) ? '0m' : formatDuration(chargerUtilizationData?.totalUtilizedTime) )}</span>
                            </div>
                            <div className={styles.topBlock}>
                                <span>Booking Duration</span>
                                <span>{ isNaN(chargerUtilizationData?.totalBookingDurationInSeconds) ? '0m' : formatDuration(chargerUtilizationData?.totalBookingDurationInSeconds)}</span>
                            </div>
                            <div className={styles.topBlock}>
                                <span>Bookings</span>
                                <span>{(chargerUtilizationData?.numberOfBookings ?? 0).toFixed(0)} Nos</span>
                            </div>
                        </div>
                     </div>

                    {!(selectedTopTab == null || selectedTopTab?.length == 0) ?
                        <div className={styles.bottomBlockContainer}>
                            <div className={styles.bottomBlock}>
                                <span>{formatDate(chargerUtilizationData?.filterResult?.filterRange?.fromDate)} - {formatDate(chargerUtilizationData?.filterResult?.filterRange?.toDate)}</span>


                                <ResponsiveContainer width="100%" height={300} >
                                    <LineChart data={chargerUtilizationData?.filterResult?.result} margin={{ top: 5, right: 5, left: 5, bottom: 5 }}>
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis dataKey="_id" />
                                        <YAxis yAxisId="three" orientation="left" stroke="#ff7300" />
                                        <YAxis yAxisId="four" orientation="right" stroke="#387908" />
                                        <Tooltip />
                                        <Legend />
                                        <Line yAxisId="three" type="monotone" name={'Number Of Bookings'} dataKey="numberOfBookingsFiltered" stroke="#ff7300" />
                                        <Line yAxisId="four" type="monotone" name={'Utilization Percentage'} dataKey="percentageUtilization" stroke="#387908" />
                                        <Line yAxisId="four" type="monotone" name={'Day Utilization Percentage'} dataKey="singleDayUtilizationPercentage" stroke="#4ae94a" />

                                    </LineChart>
                                </ResponsiveContainer>
                            </div>
                        </div>
                        :
                        <div className={styles.noChargers}>No Data Available</div>
                    }
                </>}

            </div> : undefined}

            {isLoading && <div>

                <div className={styles.topBlockContainer}>
                    <div className={`${styles.topBlock} ${styles.loading}`}>
                        <p className={`card-text placeholder-wave`}><span className="placeholder col-12"></span></p>
                    </div>
                    <div className={`${styles.topBlock} ${styles.loading}`}>
                        <p className={`card-text placeholder-wave`}><span className="placeholder col-12"></span></p>
                    </div>
                    <div className={`${styles.topBlock} ${styles.loading}`}>
                        <p className={`card-text placeholder-wave`}><span className="placeholder col-12"></span></p>
                    </div>
                </div>

                <div className={styles.bottomBlockContainer}>
                    <div className={`${styles.bottomBlock} ${styles.loading}`}>
                        <p className={`card-text placeholder-wave`}><span className="placeholder col-12"></span></p>
                    </div>
                </div>

            </div>}
        </div>

    );
};

export default ChargerMetric;
